import React from 'react';
import './VideoToCanvas.css';
import warning_adult from '../images/warning_adult_n.png';

class VideoToCanvas extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            paused: true,
            muted: false,
            length: null,
            formattedLength: null,
            currentTime: 0,
            formattedTime: null,
            volume: 0.5,

            thumbnail: this.props.thumbnail,
            imageStatus: "loading",
            imageHash: "",
            NewCanvasWidth: 0, NewCanvasHeight: 0,
            controlClose: true,
            newFrames: null,
            isVideoLoad: false,
            isNewFramesLoad: false

        };
        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }



    play() {

        this.duration();
        const v = document.getElementById("v");
        const play_pause = document.querySelector(".play_pause");

        this.setState({
            paused: !this.state.paused
        });

        if (this.state.paused === true && this.state.isVideoLoad === true && this.state.isNewFramesLoad === true) {
            v.play();

            this.setState({
                paused: false
            });
            if (this.state.playing) {
                this.onAnimationFrame();
            }


        } else {
            v.pause();
            this.setState({
                paused: true,
                formattedTime: "loading"
            });
        }
    }

    duration() {
        let dur = document.getElementById("v").duration;
        dur = dur.toFixed();
        let formattedLength = dur.toHHMMSS();

        this.setState({
            length: dur,
            formattedLength: formattedLength
        });

        return dur;
    }

    currentTime() {
        String.prototype.toHHMMSS = function () {
            let sec_num = parseInt(this, 10);
            let hours = Math.floor(sec_num / 3600);
            let minutes = Math.floor((sec_num - hours * 3600) / 60);
            let seconds = sec_num - hours * 3600 - minutes * 60;

            if (hours < 10) {
                hours = "0" + hours;
            }
            if (minutes < 10) {
                minutes = "0" + minutes;
            }
            if (seconds < 10) {
                seconds = "0" + seconds;
            }

            return hours + ":" + minutes + ":" + seconds;
        };

        let cur = document.getElementById("v").currentTime;
        cur = cur.toFixed();
        let formattedTime = cur.toHHMMSS();

        this.setState({
            currentTime: cur,
            formattedTime: formattedTime
        });
        if (parseInt(this.state.currentTime) === parseInt(this.state.length)) {
            this.setState({ paused: true });
        }

        return cur;
    }

    customTime() {
        const time_range = document.querySelector(".time_range");
        document.getElementById("v").currentTime = time_range.value;

        this.setState({
            currentTime: time_range.value
        });
    }

    customVolume() {
        const volume_range = document.querySelector(".volume_range");
        document.getElementById("v").volume = volume_range.value;

        this.setState({
            volume: volume_range.value
        });

        if (volume_range.value === 0) {
            this.setState({
                muted: true
            });
        } else {
            this.setState({
                muted: false
            });
        }
    }

    mute() {
        document.getElementById("v").muted = true;

        this.setState({
            muted: true
        });

        if (this.state.muted === true) {
            document.getElementById("v").muted = false;

            this.setState({
                muted: false
            });
        } else {
            document.getElementById("v").muted = true;
            this.setState({
                muted: true
            });
        }
    }

    onAnimationFrame() {

        const video = document.getElementById("v");
        var canvas = document.getElementById('canvas_vq');
        var context = canvas.getContext('2d');
        const thumbnail = document.getElementById("imgThumbnail");

        // var canvas2 = document.getElementById('canvas_bg');
        // var context2 = canvas2.getContext('2d');

        if (!video.paused) {

            this.adultControl(context);
            this.setState({ paused: false })
            const render = () => {
                var videoWidth = this.props.frameWidth;
                var videoHeight = this.props.frameHeight;

                // context2.drawImage(video, 0, 0, this.props.width, this.props.height);
                // context2.filter = 'blur(8px)'
                // context.drawImage(canvas2, 0, 0, this.props.width, this.props.height);

                var wrh = videoWidth / videoHeight;
                var newWidth = canvas.width;
                var newHeight = newWidth / wrh;

                if (newHeight > canvas.height) {
                    newHeight = canvas.height;
                    newWidth = newHeight * wrh;
                }
                var xOffset = newWidth < canvas.width ? ((canvas.width - newWidth) / 2) : 0;
                var yOffset = newHeight < canvas.height ? ((canvas.height - newHeight) / 2) : 0;


                if (this.props?.isAdult === true && this.props?.anlystTokenOK == false) {

                    context.drawImage(thumbnail, 0, 0, this.state?.NewCanvasWidth, this.state?.NewCanvasHeight);
                }
                else {
                    context.drawImage(video, xOffset, yOffset, newWidth, newHeight);
                    let cur = document.getElementById("v").currentTime

                    this.checkFrameinJson(this.getFrameNumber(cur))
                }



            };
            if (video) {
                render();

                if (this.state.playing) {
                    this.onAnimationFrame();
                }
            }
        }
        else {


            if (this.state?.imageStatus === "loaded" && this.state?.currentTime === 0) {


                context.drawImage(thumbnail, 0, 0, this.state?.NewCanvasWidth, this.state?.NewCanvasHeight);
            }
        }
    }

    checkFrameinJson(frameNumber) {
        var fps = 15;
        // var frameNumber;
        var x1;
        var x2;
        var y1;
        var y2;
        var points;
        var pred;
        var arrIds;
        var isFake;

        var arrFrames = Object.keys(this.state.newFrames);
        if (arrFrames.includes(frameNumber.toString())) {
            arrIds = Object.keys(this.state.newFrames[frameNumber.toString()].ids);
            var i;
            for (i = 0; i < arrIds.length; i++) {
                x1 = this.state.newFrames[frameNumber.toString()]["ids"][arrIds[i].toString()].box[0];
                x2 = this.state.newFrames[frameNumber.toString()]["ids"][arrIds[i].toString()].box[1];
                y1 = this.state.newFrames[frameNumber.toString()]["ids"][arrIds[i].toString()].box[2];
                y2 = this.state.newFrames[frameNumber.toString()]["ids"][arrIds[i].toString()].box[3];
                points = this.state.newFrames[frameNumber.toString()]["ids"][arrIds[i].toString()].point;
                pred = this.state.newFrames[frameNumber.toString()]["ids"][arrIds[i].toString()].pred;

                if (typeof this.props?.resultInfo !== "undefined" && this.props?.resultInfo["fake_person_id"].includes(parseInt(arrIds[i].toString().replace("id_", "")))) {
                    isFake = true;
                }

                this.drawFaceBox(x1, x2, y1, y2, points, pred, isFake, frameNumber.toString());
            }
        }
    }
    createInterpolatedFrames() {


        if (this.props?.fps > 0 && !this.state.isNewFramesLoad) {
            if (this.props?.frames !== null && this.state.length > 0) {

                const obj = {}
                var arrFrames = Object.keys(this.props?.frames);
                var frameCount = this.state.length * Math.ceil(this.props?.fps);

                var arrIds;

                for (var frameNumber = 0; frameNumber < frameCount; frameNumber++) {

                    if (arrFrames.includes(frameNumber.toString())) {

                        arrIds = Object.keys(this.props?.frames[frameNumber.toString()].ids);
                        this.addFramesToNewArr(frameNumber, frameNumber, arrIds, obj);
                    }
                }
                // if (Object.keys(obj).length > 0) {
                //     // console.log(obj);
                //     this.setState({
                //         newFrames: obj,
                //         isNewFramesLoad: true
                //     })

                // }
                // console.log(obj);
                // console.log(this.props?.fps)
                // console.log(this.props?.frames)
                // console.log(this.state.length)

                setInterval(() => this.setState({ newFrames: obj }), 100);
                setInterval(() => this.setState({ isNewFramesLoad: true }), 10);


            }
        }
    }
    addFramesToNewArr(frameNumber, frameSecond, arrIds, obj) {

        var fps = Math.ceil(this.props?.fps);
        var i;
        var arrFrames = Object.keys(this.props?.frames);

        for (i = 0; i < arrIds.length; i++) {

            var points = this.props?.frames[frameSecond.toString()]["ids"][arrIds[i].toString()].point;
            var pred = this.props?.frames[frameSecond.toString()]["ids"][arrIds[i].toString()].pred;

            var keyString = frameNumber + ".ids.id_" + i + ".box";
            this.setObj(obj, keyString, this.props?.frames[frameSecond.toString()]["ids"][arrIds[i].toString()].box);

            var keyString2 = frameNumber + ".ids.id_" + i + ".point";
            this.setObj(obj, keyString2, points);

            var keyString2 = frameNumber + ".ids.id_" + i + ".pred";
            this.setObj(obj, keyString2, pred);


            var nextFrame = frameNumber + fps;

            if (arrFrames.includes(nextFrame.toString())) {
                var arrIds2 = Object.keys(this.props?.frames[nextFrame.toString()].ids);
                if (arrIds2.includes(arrIds[i].toString())) {
                    var frameStep;
                    var say = 1;
                    var pointOld;
                    var pointNext;
                    for (frameStep = frameNumber + 1; frameStep < nextFrame; frameStep++) {

                        var x11 = parseInt(this.props?.frames[frameNumber.toString()]["ids"][arrIds[i].toString()].box[0]);
                        var x12 = parseInt(this.props?.frames[frameNumber.toString()]["ids"][arrIds[i].toString()].box[1]);
                        var y11 = parseInt(this.props?.frames[frameNumber.toString()]["ids"][arrIds[i].toString()].box[2]);
                        var y12 = parseInt(this.props?.frames[frameNumber.toString()]["ids"][arrIds[i].toString()].box[3]);

                        var x21 = parseInt(this.props?.frames[nextFrame.toString()]["ids"][arrIds[i].toString()].box[0]);
                        var x22 = parseInt(this.props?.frames[nextFrame.toString()]["ids"][arrIds[i].toString()].box[1]);
                        var y21 = parseInt(this.props?.frames[nextFrame.toString()]["ids"][arrIds[i].toString()].box[2]);
                        var y22 = parseInt(this.props?.frames[nextFrame.toString()]["ids"][arrIds[i].toString()].box[3]);

                        var xstep1 = (x21 - x11) / fps;
                        var xstep2 = (x22 - x12) / fps;
                        var x1 = (xstep1 * say) + x11;
                        var x2 = (xstep2 * say) + x12;

                        var y1 = this.interpolation(x1, x11, x21, y11, y21);
                        if (xstep1 === 0) {

                            y1 = ((y21 - y11) / say) + y11
                            x1 = x11;
                        }
                        var y2 = this.interpolation(x2, x12, x22, y12, y22);
                        if (xstep2 === 0) {

                            y2 = ((y22 - y12) / say) + y12
                            x2 = x12;
                        }

                        var box = [x1, x2, y1, y2];
                        this.addInterpoledFrame(frameStep, pred, box, obj, "id_" + i);

                        // var pointOld = this.props?.frames[frameNumber.toString()]["ids"][arrIds[i].toString()].point;
                        // var pointNext = this.state.frames[nextFrame.toString()]["ids"][arrIds[i].toString()].point;
                        // this.addInterpolatedPoint(pointOld, pointNext, frameStep, say, obj, "id_" + i);



                        say++;
                    }

                }
            }
        }
    }
    addInterpolatedPoint(pointOld, pointNext, frameNumber, say, obj, id) {
        var fps = Math.ceil(this.props.fps);
        var points = [];
        var i;
        for (i = 0; i < 5; i++) {
            var x1 = pointOld[i][0];
            var y1 = pointOld[i][1];

            var x2 = pointNext[i][0];
            var y2 = pointNext[i][1];

            var xstep1 = (x2 - x1) / fps;
            var x = (xstep1 * say) + x1;

            var y = this.interpolation(x, x1, x2, y1, y2);

            if (xstep1 === 0) {
                y = ((y2 - y1) / say) + y1
                x = x1;
            }
            var point = [];
            point.push(x);
            point.push(y);
            points.push(point);
        }

        var keyString = frameNumber + ".ids." + id + ".point";
        this.setObj(obj, keyString, points);

    }
    addInterpoledFrame(frameNumber, pred, box, obj, id) {

        var keyString = frameNumber + ".ids." + id + ".box";
        this.setObj(obj, keyString, box);
        var keyString2 = frameNumber + ".ids." + id + ".pred";
        this.setObj(obj, keyString2, pred);

    }

    interpolation = (x, x1, x2, y1, y2) => {
        var y = y1 + (x - x1) * ((y2 - y1) / (x2 - x1));
        return y;

    }


    setObj = (obj, path, val) => {
        const keys = path.split('.');
        const lastKey = keys.pop();
        const lastObj = keys.reduce((obj, key) =>
            obj[key] = obj[key] || {},
            obj);
        lastObj[lastKey] = val;
    };

    drawFaceBox(x01, x02, y01, y02, points, pred, isFake, frame) {

        var canvas = document.getElementById('canvas_vq');
        var videoWidth = this.props.frameWidth;
        var videoHeight = this.props.frameHeight;

        var wrh = videoWidth / videoHeight;
        var newWidth = canvas.width;
        var newHeight = newWidth / wrh;
        var kx = 1;
        var ky = 1;
        kx = canvas.width / videoWidth;
        ky = canvas.height / videoHeight;
        if (newHeight > canvas.height) {
            newHeight = canvas.height;
            newWidth = newHeight * wrh;
            ky = canvas.height / videoHeight;
            kx = ky;
        }

        var xOffset = newWidth < canvas.width ? ((canvas.width - newWidth) / 2) : 0;
        var yOffset = newHeight < canvas.height ? ((canvas.height - newHeight) / 2) : 0;

        var x1 = xOffset + (x01 * kx);
        var x2 = xOffset + (x02 * kx);
        var y1 = yOffset + (y01 * ky);
        var y2 = yOffset + (y02 * ky);


        if (canvas.getContext) {
            var ctx = canvas.getContext('2d');
            var color;
            ctx.lineWidth = 3;
       
            if (isFake || (pred * 100) > 79) {
                color = "#FF0000";
            }
            else {
                color = "#42d60e";
            }


            ctx.strokeStyle = color;
            ctx.fillStyle = color;

            ctx.beginPath();
            ctx.moveTo(x1, y1);
            ctx.lineTo(x1, y2);
            ctx.moveTo(x1, y2);
            ctx.lineTo(x2, y2);
            ctx.moveTo(x2, y2);
            ctx.lineTo(x2, y1);
            ctx.moveTo(x2, y1);
            ctx.lineTo(x1, y1);

            ctx.fillRect(x2 - 70, y2 - 0, 70, 20);
            ctx.stroke();
            ctx.beginPath();
            ctx.fillStyle = "white";
            ctx.font = "12px Comic Sans MS";
            ctx.textAlign = "center";
            ctx.fillText("Pred: " + pred.toString(), x2 - 35, y2 + 15);
            ctx.stroke();

            // var i2;
            // for (i2 = 0; i2 < points.length; i2++) {
            //     var px = xOffset + (points[i2][0] * kx);
            //     var py = yOffset * 0 + (points[i2][1] * ky);

            //     ctx.beginPath();
            //     ctx.lineWidth = 1;
            //     ctx.arc(px, py, 3, 0, 2 * Math.PI);
            //     ctx.stroke();

            // }

            // if (isFake) {
            //     ctx.beginPath();
            //     ctx.fillStyle = color;
            //     ctx.fillRect(x2 - 70, y2 + 0, 70, 20);
            //     ctx.stroke();
            //     ctx.beginPath();
            //     ctx.fillStyle = "white";
            //     ctx.font = "12px Comic Sans MS";
            //     ctx.textAlign = "center";
            //     ctx.fillText("Avg: FAKE", x2 - 35, y2 + 15);
            //     ctx.stroke();
            // }
        }
    }

    getFrameNumber() {
        let cur = document.getElementById("v").currentTime;

        return Math.floor(cur.toFixed(5) * Math.ceil(this.props.fps));

        //return Math.floor(cur.toFixed(5) * 30);
    }

    adultControl(context) {

        if (this.props?.isAdult === true && this.props?.anlystTokenOK == false) {
            this.setState({ muted: true, volume: 0, controlClose: true });
            document.getElementById("v").volume = 0;
            // context.filter = 'blur(38px)';
        }


    }

    handleImageLoaded() {

        this.setState({ imageStatus: "loaded" });

        this.updateWindowDimensions(true);
    }

    handleImageErrored() {

        this.setState({ imageStatus: "failed to load" });
    }

    handleVideoLoaded() {
        //  setTimeout(() => {  console.log("World!"); }, 5000);
        // console.log("video load");
        this.createInterpolatedFrames();
        this.setState({ isVideoLoad: true });
    }

    setWrapperRef(node) {
        this.wrapperRef = node;
    }


    handleClickOutside(event) {
        if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
            this.setState({ controlClose: true });
        }
    }
    canvasClick() {
        this.play();
        this.setState({ controlClose: !this.state?.controlClose });

    }
    updateWindowDimensions(loaded = false) {

        var VideoPlayer = document.getElementById('VideoPlayer');
        var canvas_vq = document.getElementById('canvas_vq');
        var context = canvas_vq.getContext('2d');
        var video = document.getElementById('v');
        var wrh = this.props?.width / this.props?.height;

        var newWidth = 0;
        var newHeight = 0;
        if (this.props?.height < this.props?.width) {
            newWidth = VideoPlayer.offsetWidth;
            newHeight = newWidth / wrh;
        }
        else {
            newHeight = 400;
            newWidth = newHeight * wrh;
        }
        canvas_vq.width = newWidth;
        canvas_vq.height = newHeight;
        this.setState({ NewCanvasWidth: newWidth, NewCanvasHeight: newHeight })
        if (video.paused) {
            const thumbnail = document.getElementById("imgThumbnail");
            if (loaded === true) {

                context.drawImage(thumbnail, 0, 0, this.state?.NewCanvasWidth, this.state?.NewCanvasHeight);
            }
        }

    }

    componentDidMount() {
        if (this.props?.isAdult !== true && this.props?.anlystTokenOK == false) {
            this.customVolume();
        }
        setInterval(() => this.setState({ currentTime: this.currentTime() }), 10);

        setInterval(() => this.setState({ length: this.duration() }), 10);
        setInterval(() => this.setState(this.onAnimationFrame()), 10);
        this.setState({

            imageHash: Date.now(),

        })
        var video = document.getElementById('v');
        video.load();
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
        document.addEventListener('mousedown', this.handleClickOutside);
        this.createInterpolatedFrames();
    }
    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }
    componentWillReceiveProps(nProps) {
        setInterval(() => this.setState({ currentTime: this.currentTime() }), 10);

        setInterval(() => this.setState({ length: this.duration() }), 10);
        setInterval(() => this.setState(this.onAnimationFrame()), 10);
        this.setState({


            thumbnail: nProps.thumbnail,
            imageHash: Date.now(),

        })

        var video = document.getElementById('v');
        video.load();

        this.createInterpolatedFrames();
        this.updateWindowDimensions();

    }

    componentDidUpdate(prevProps) {

        if (this.props?.width !== prevProps.width) {
            this.updateWindowDimensions()
        }
        if (this.state?.isNewFramesLoad === false) {
            this.createInterpolatedFrames();
        }
    }

    render() {
        return (

            <div className="VideoPlayer" id="VideoPlayer" ref={this.setWrapperRef}>


                <video
                    id="v"
                    width="100%"
                    height="100%"
                    hidden
                    autoPlay={false}
                    onLoadedData={this.handleVideoLoaded.bind(this)}
                >
                    <source src={this.props?.src} type="video/mp4" />
                </video>
                <img id="imgThumbnail" src={
                    this.props?.isAdult && this.props?.anlystTokenOK == false ?
                        warning_adult
                        :
                        `${this.props?.thumbnail}?${this.state?.imageHash}`

                }
                    onLoad={this.handleImageLoaded.bind(this)}
                    onError={this.handleImageErrored.bind(this)}
                    hidden ></img>
                <canvas
                    id="canvas_vq"
                    width="100%"
                    onClick={this.canvasClick.bind(this)}
                    style={{ cursor: 'pointer' }}

                />
                {/* <canvas
                    id="canvas_bg"
                    height={this.props?.height}
                    width={this.props?.width}
                    hidden
                /> */}

                {
                    this.props?.isAdult && this.props?.anlystTokenOK == false ?
                        "" :
                        <div className={this.state?.controlClose ? "controlsClose controls" : "controlsOpen controls"}>

                            <button onClick={this.play.bind(this)} className="play_pause_btn">
                                <svg
                                    className={this.state?.paused ? "svg_play_pause" : "hide"}
                                    viewBox="0 0 232.153 232.153"
                                >
                                    <path d="M203.791,99.628L49.307,2.294c-4.567-2.719-10.238-2.266-14.521-2.266
c-17.132,0-17.056,13.227-17.056,16.578v198.94c0,2.833-0.075,16.579,17.056,16.579c4.283,0,9.955,0.451,14.521-2.267
l154.483-97.333c12.68-7.545,10.489-16.449,10.489-16.449S216.471,107.172,203.791,99.628z" />
                                </svg>

                                <svg
                                    className={this.state?.paused ? "hide" : "svg_play_pause"}
                                    viewBox="0 0 232.153 232.153"
                                >
                                    <path d="M80.543,0H35.797c-9.885,0-17.898,8.014-17.898,17.898v196.883
c0,9.885,8.013,17.898,17.898,17.898h44.746c9.885,0,17.898-8.013,17.898-17.898V17.898C98.44,8.014,90.427,0,80.543,0z M196.882,0
h-44.746c-9.886,0-17.899,8.014-17.899,17.898v196.883c0,9.885,8.013,17.898,17.899,17.898h44.746
c9.885,0,17.898-8.013,17.898-17.898V17.898C214.781,8.014,206.767,0,196.882,0z" />
                                </svg>

                            </button>

                            <span className="time">

                                {this.state.isNewFramesLoad ?
                                    <span className="video_time">{this.state?.formattedTime} </span>
                                    : ""}
                                <span> / </span>
                                {this.state.isNewFramesLoad ?
                                    <span className="video_length">{this.state?.formattedLength}</span> :
                                    <span className="video_length"> Loading...</span>}
                            </span>

                            <input
                                type="range"
                                className="time_range"
                                onChange={this.customTime?.bind(this)}
                                value={this.state?.currentTime}
                                step={0.1}
                                min={0}
                                max={this.state?.length}
                            />

                            <button onClick={this.mute?.bind(this)} className="mute_unmute_btn">

                                <svg
                                    className={this.state?.muted ? "hide" : "svg_mute_unmute"}
                                    viewBox="0 0 20 20"
                                >
                                    <path
                                        fill="none"
                                        d="M9.344,2.593c-0.253-0.104-0.547-0.045-0.743,0.15L4.486,6.887H1.313c-0.377,0-0.681,0.305-0.681,0.681v4.916c0,0.377,0.304,0.681,0.681,0.681h3.154l4.137,4.142c0.13,0.132,0.304,0.201,0.482,0.201c0.088,0,0.176-0.017,0.261-0.052c0.254-0.105,0.42-0.354,0.42-0.629L9.765,3.224C9.765,2.947,9.599,2.699,9.344,2.593z M5.233,12.003c-0.128-0.127-0.302-0.2-0.483-0.2H1.994V8.249h2.774c0.182,0,0.355-0.072,0.483-0.201l3.151-3.173l0.001,10.305L5.233,12.003z"
                                    />
                                    <path
                                        fill="none"
                                        d="M16.434,10.007c0-2.553-1.518-4.853-3.869-5.858C12.223,4,11.821,4.16,11.672,4.506c-0.148,0.346,0.013,0.746,0.359,0.894c1.846,0.793,3.041,2.6,3.041,4.608c0,1.997-1.188,3.799-3.025,4.592c-0.346,0.149-0.505,0.551-0.356,0.895c0.112,0.258,0.362,0.411,0.625,0.411c0.091,0,0.181-0.017,0.269-0.056C14.922,14.843,16.434,12.548,16.434,10.007z"
                                    />
                                    <path
                                        fill="none"
                                        d="M13.418,10.005c0-1.349-0.802-2.559-2.042-3.086c-0.346-0.144-0.745,0.015-0.894,0.362c-0.146,0.346,0.016,0.745,0.362,0.893c0.737,0.312,1.212,1.031,1.212,1.832c0,0.792-0.471,1.509-1.2,1.825c-0.345,0.149-0.504,0.551-0.352,0.895c0.112,0.257,0.362,0.41,0.625,0.41c0.091,0,0.181-0.017,0.27-0.057C12.625,12.545,13.418,11.339,13.418,10.005z"
                                    />
                                    <path
                                        fill="none"
                                        d="M13.724,1.453c-0.345-0.15-0.746,0.012-0.895,0.358c-0.148,0.346,0.013,0.745,0.358,0.894c2.928,1.256,4.819,4.122,4.819,7.303c0,3.171-1.886,6.031-4.802,7.289c-0.346,0.149-0.505,0.55-0.356,0.894c0.112,0.258,0.362,0.412,0.626,0.412c0.09,0,0.181-0.019,0.269-0.056c3.419-1.474,5.626-4.826,5.626-8.54C19.368,6.282,17.152,2.923,13.724,1.453z"
                                    />
                                </svg>

                                <svg
                                    className={this.state?.muted ? "svg_mute_unmute" : "hide"}
                                    viewBox="0 0 20 20"
                                >
                                    <path
                                        fill="none"
                                        d="M3.401,13.367h0.959l1.56-1.56H4.181v-4.07h3.177c0.207,0,0.405-0.084,0.553-0.23l3.608-3.633V6.21l1.56-1.56V1.983c0-0.315-0.192-0.602-0.485-0.721c-0.29-0.122-0.624-0.055-0.85,0.171L7.032,6.178h-3.63c-0.433,0-0.78,0.349-0.78,0.78v5.629C2.621,13.018,2.968,13.367,3.401,13.367z"
                                    />
                                    <path
                                        fill="none"
                                        d="M11.519,15.674l-2.416-2.418L8,14.358l3.745,3.753c0.149,0.149,0.349,0.228,0.553,0.228c0.1,0,0.201-0.019,0.297-0.059c0.291-0.12,0.483-0.405,0.483-0.72V9.28l-1.56,1.56V15.674z"
                                    />
                                    <path
                                        fill="none"
                                        d="M19.259,0.785c-0.167-0.168-0.387-0.25-0.606-0.25s-0.438,0.082-0.606,0.25l-4.968,4.968l-1.56,1.56l-4.496,4.494l-1.56,1.56L0.83,18.001c-0.335,0.335-0.335,0.877,0,1.213c0.167,0.167,0.386,0.251,0.606,0.251c0.22,0,0.439-0.084,0.606-0.251l5.407-5.407l1.105-1.104l2.965-2.966l1.56-1.56l6.18-6.181C19.594,1.664,19.594,1.12,19.259,0.785z"
                                    />
                                </svg>
                            </button>

                            <input
                                type="range"
                                className="volume_range"
                                onChange={this.customVolume.bind(this)}
                                value={this.state?.volume}
                                step={0.1}
                                min={0}
                                max={1}
                            />
                        </div>

                }


            </div>
        );
    }

}


export default VideoToCanvas;